export default {
	GET_SHOP_LIST: (state, data) => {
		state.shopList = data
	},

	GET_ALL_SHOP_LIST: (state, data) => {
		state.list = data
	},
}



// WEBPACK FOOTER //
// ./src/store/mp/shops/shop_manage/mutations.js